var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_51475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5682 0.181641H11.25C9.55611 0.181641 8.17543 1.57511 8.23935 3.26261C8.25213 3.60138 8.26491 3.94016 8.28409 4.27255H1.53409C0.683949 4.27255 0 4.9565 0 5.80664C0 11.7257 2.14134 15.8422 5.01776 18.6355C7.84943 21.3904 11.3011 22.7775 13.8452 23.4806C15.3409 23.8961 16.3636 25.1426 16.3636 26.3954C16.3636 27.7314 15.277 28.818 13.9411 28.818H12.2727C11.1413 28.818 10.2273 29.7321 10.2273 30.8635C10.2273 31.9949 11.1413 32.9089 12.2727 32.9089H24.5455C25.6768 32.9089 26.5909 31.9949 26.5909 30.8635C26.5909 29.7321 25.6768 28.818 24.5455 28.818H22.8771C21.5412 28.818 20.4545 27.7314 20.4545 26.3954C20.4545 25.1426 21.4709 23.8897 22.973 23.4806C25.5234 22.7775 28.9751 21.3904 31.8068 18.6355C34.6768 15.8422 36.8182 11.7257 36.8182 5.80664C36.8182 4.9565 36.1342 4.27255 35.2841 4.27255H28.5341C28.5533 3.94016 28.5661 3.60778 28.5788 3.26261C28.6428 1.57511 27.2621 0.181641 25.5682 0.181641ZM3.12571 7.34073H8.5206C9.10227 13.1 10.3871 16.948 11.8381 19.524C10.2464 18.8208 8.59091 17.8301 7.15909 16.4366C5.11364 14.4487 3.4517 11.5787 3.1321 7.34073H3.12571ZM29.6655 16.4366C28.2337 17.8301 26.5781 18.8208 24.9865 19.524C26.4375 16.948 27.7223 13.1 28.304 7.34073H33.6989C33.3729 11.5787 31.7109 14.4487 29.6719 16.4366H29.6655Z",
    fill: "#16A34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_51475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.181641H36.8182V32.9089H0V0.181641Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.0c08f15cbb897e36c77f142d0424aeba.svg";
export { ForwardRef as ReactComponent };